// Small SEO helper used by pages to update <title>, description and canonical URL.
export function applySeo({ title, description, canonicalPath }) {
  if (title) document.title = title;
  if (description) {
    const m = document.querySelector('meta[name="description"]');
    if (m) m.setAttribute("content", description);
  }
  if (canonicalPath !== undefined) {
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    const path = canonicalPath || window.location.pathname;
    link.setAttribute("href", window.location.origin + path);
  }
}
